import axios from 'axios'
import { BUSCAR_HISTORICOS_TRANSFERENCIA_PASSAGEIROS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarHistoricosTransferenciaPassageiros (itinerarioId, empresaId) {
  let url = `${URL}/itinerario/${itinerarioId}/empresa/${empresaId}/historicos-transferencias-passageiros`;
  
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_HISTORICOS_TRANSFERENCIA_PASSAGEIROS,
        payload: response

      })
  );
}
